import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { mapInvoiceStreamName } from '@/shared/services/ObjectDisplayService';
import AutoComplete from './select/AutoComplete';
export var InvoiceStreamSelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, onChange = _a.onChange, invoiceStreams = _a.invoiceStreams;
    var intl = useIntl();
    var items = useMemo(function () {
        var _a;
        return (_a = invoiceStreams === null || invoiceStreams === void 0 ? void 0 : invoiceStreams.filter(function (x) { return x.isActive || (!!initialValue && x.id === initialValue); })) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
            key: item.id,
            label: mapInvoiceStreamName(item, intl),
        }); });
    }, [invoiceStreams, intl, initialValue]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); } }));
};
